import React from 'react'
import { Link } from 'react-router-dom'

const Cta = () => {
  return (
      <section className="section section--alt">
        <div className="container">
          <div className="cta-banner">
            <h2 className="cta-banner__title">
              Pronto para ter uma TI
              <br />
              que realmente funciona?
            </h2>
            <p className="cta-banner__sub">
              Fale com nossos especialistas e descubra como a sepolTECH pode
              transformar a tecnologia da sua empresa.
            </p>
            <div className="cta-banner__actions">
              <Link to="/contato" className="btn btn-primary">
                Falar com um especialista →
              </Link>
              <Link to="/faq" className="btn btn-outline">
                Perguntas frequentes
              </Link>
            </div>
          </div>
        </div>
      </section>
  )
}

export default Cta